<template>
  <div class="d-flex flex-column">
    <template v-for="item, index in messages" :key="index">
      <AIAssistantMessagesItem :item="item" />
    </template>
    <div class="loading-state" v-if="postPromptPending">
      <AppChatMessage class="pb-6">
        <template #message-author>
          <app-icon-ai-assistant :width="32" :height="32" />
        </template>
        <div class="d-flex column-gap-4 align-center">
          <app-material-icon name="progress_activity" class="fa-spin text-purple-darken-1" />
          {{ $t(`${TRANSLATION_KEY_PREFIX}.postPromptPending`) }}
        </div>
      </AppChatMessage>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AIAssistantMessagesItem from '@/common/ai-assistant/AIAssistantMessagesItem.vue'
import AppChatMessage from '@/common/app-chat/AppChatMessage.vue'
import type { AIAssistantConversationMessage } from '@/types/ai-assistant'

const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantMessages'

export default defineComponent({
  name: 'AIAssistantMessages',
  components: {
    AppChatMessage,
    AIAssistantMessagesItem,
  },
  props: {
    messages: {
      type: Array as PropType<AIAssistantConversationMessage[]>,
      required: true,
    },
    postPromptPending: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
})
</script>